import type { ReactNode } from 'react';
import { MapPinned } from 'lucide-react';
import { PointAssociationSection } from './PointAssociationSection';
import './point-entity-details-panel.css';

export interface PointEntityDetailField {
  label: string;
  value: ReactNode;
}

export interface PointEntityDetailsPanelProps {
  title: string;
  code?: string | null;
  subtitle?: string | null;
  projectId: string;
  entityType: string;
  entityId: string;
  coordinates: [number, number];
  fields: PointEntityDetailField[];
  onClose: () => void;
}

export function PointEntityDetailsPanel({
  title,
  code,
  subtitle,
  projectId,
  entityType,
  entityId,
  coordinates,
  fields,
  onClose,
}: PointEntityDetailsPanelProps): JSX.Element {
  return (
    <div className="point-entity-details-panel">
      <div className="point-entity-details-panel__header">
        <div>
          <div className="point-entity-details-panel__eyebrow">
            <MapPinned size={14} />
            <span>{title}</span>
          </div>
          {code && <h2 className="point-entity-details-panel__code">{code}</h2>}
          {subtitle && <p className="point-entity-details-panel__subtitle">{subtitle}</p>}
        </div>
      </div>

      <div className="point-entity-details-panel__section">
        <div className="point-entity-details-panel__grid">
          {fields.map((field) => (
            <div key={field.label} className="point-entity-details-panel__field">
              <span className="point-entity-details-panel__label">{field.label}</span>
              <span className="point-entity-details-panel__value">{field.value}</span>
            </div>
          ))}
        </div>
      </div>

      <PointAssociationSection
        projectId={projectId}
        entityType={entityType}
        entityId={entityId}
        coordinates={coordinates}
      />

      <div className="point-entity-details-panel__actions">
        <button
          type="button"
          className="point-entity-details-panel__close"
          onClick={onClose}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
}
